import { Routes } from '@angular/router';
import { AuthGuardPermission } from '../auth/auth.guard-permission';
import { TenantFeatureGuard } from '../tenant/tenant-feature.service';

/** Top-level team CMS routes (no `/team-content` prefix). */
export const teamSectionRoutes: Routes = [
  {
    path: 'teams',
    loadComponent: () =>
      import('./team-list/team-list.component').then((m) => m.TeamListComponent),
    canActivate: [TenantFeatureGuard],
    data: { tenantModule: 'teams' },
  },
  {
    path: 'team-manager',
    loadComponent: () =>
      import('./team-manager/team-manager.component').then((m) => m.TeamManagerComponent),
    canActivate: [AuthGuardPermission, TenantFeatureGuard],
    data: { permission: 'teams.manage', tenantModule: 'teams' },
  },
  {
    path: 'add-team',
    loadComponent: () =>
      import('./team-create/team-create.component').then((m) => m.TeamCreateComponent),
    canActivate: [AuthGuardPermission, TenantFeatureGuard],
    data: { permission: 'teams.manage', tenantModule: 'teams' },
  },
  {
    path: 'edit-team/:teamId',
    loadComponent: () =>
      import('./team-create/team-create.component').then((m) => m.TeamCreateComponent),
    canActivate: [AuthGuardPermission, TenantFeatureGuard],
    data: { permission: 'teams.manage', tenantModule: 'teams' },
  },
  {
    path: 'import-teams',
    loadComponent: () =>
      import('./team-import/team-import.component').then((m) => m.TeamImportComponent),
    canActivate: [AuthGuardPermission, TenantFeatureGuard],
    data: { permission: 'teams.manage', tenantModule: 'teams' },
  },
];
